import { MIN_DESKTOP } from '@shared/constants';

export const breakpoints = {
  mobile: `(max-width: ${MIN_DESKTOP - 1}px)`,
  desktop: `(min-width: ${MIN_DESKTOP}px)`,
};
